import { environment } from './environments/environment';

const awsconfigmanagement = {
    Auth: {
        Cognito: {
            userPoolId: environment.MANAGEMENT_USER_POOL,
            userPoolClientId: environment.MANAGEMENT_APP_CLIENT_ID,
            loginWith: { email: true },
        },
    },
};
export default awsconfigmanagement;
